/**
 * Contexto da gravação da chamada. Fica num arquivo próprio (sem importar o LiveKit nem a API) para quem só LÊ o estado
 * (botão, aviso, aceite do convidado) não puxar o provedor junto, como o da transcrição.
 */
import { createContext, useContext } from 'react';

export const RecordingContext = createContext(null);

/** `null` fora do provedor: a sala não tem gravação (chamada sem ela ligada). */
export const useCallRecording = () => useContext(RecordingContext);
